import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { useRole, ROLES } from './RoleContext';

const FeatureFlagContext = createContext();

export function useFeatureFlags() {
  return useContext(FeatureFlagContext);
}

// Feature flags configuration
const FEATURE_FLAGS = {
  // Restrict dashboard, properties, profile, and favorites to admin-only
  ADMIN_ONLY_ACCESS: true,
};

export function FeatureFlagProvider({ children }) {
  const { currentUser } = useAuth();
  const { hasRole, loading: roleLoading } = useRole();
  const [flags, setFlags] = useState(FEATURE_FLAGS);

  // Check if user has access to protected features
  const hasFeatureAccess = (featureName) => {
    // If feature doesn't exist, default to true (allow access)
    if (!flags[featureName]) {
      return true;
    }

    // Check specific feature flags
    switch (featureName) {
      case 'ADMIN_ONLY_ACCESS':
        // Only admins can access when this flag is enabled
        return hasRole(ROLES.ADMIN);
      default:
        return true;
    }
  };

  // Check if user can access dashboard
  const canAccessDashboard = () => {
    if (!flags.ADMIN_ONLY_ACCESS) return true;
    return hasRole(ROLES.ADMIN);
  };

  // Check if user can access properties page
  const canAccessProperties = () => {
    if (!flags.ADMIN_ONLY_ACCESS) return true;
    return hasRole(ROLES.ADMIN);
  };

  // Check if user can access profile
  const canAccessProfile = () => {
    if (!flags.ADMIN_ONLY_ACCESS) return true;
    return hasRole(ROLES.ADMIN);
  };

  // Check if user can access favorites
  const canAccessFavorites = () => {
    if (!flags.ADMIN_ONLY_ACCESS) return true;
    return hasRole(ROLES.ADMIN);
  };

  const value = {
    flags,
    setFlags,
    hasFeatureAccess,
    canAccessDashboard,
    canAccessProperties,
    canAccessProfile,
    canAccessFavorites,
    loading: roleLoading,
  };

  return (
    <FeatureFlagContext.Provider value={value}>
      {children}
    </FeatureFlagContext.Provider>
  );
}


